import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React, { useState } from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar1 from './Components/Navbar';
import Ingles from './ingles/Ingles';
import Contact from './ingles/Contact'; // Verifique o caminho correto
import Projects from './ingles/Projects'; // Verifique o caminho correto
import OurTeam from './ingles/OurTeam'; // Verifique o caminho correto
 // Verifique o caminho correto
import Building from './ingles/Building'; // Verifique o caminho correto
import InformationTechnology from './ingles/InformationTechnology'; // Verifique o caminho correto
import OurServices from './ingles/OurServices'; // Verifique o caminho correto
 // Verifique o caminho correto
import Home from './views/Home'; // Verifique o caminho correto
import Orcamento from './views/Orcamento'; // Verifique o caminho correto
 // Verifique o caminho correto
import NossoTeam from './views/NossoTeam'; // Verifique o caminho correto
import NossosServicos from './views/NossosServicos'; // Verifique o caminho correto
import Manutencaopredial from './views/Manutencaopredial'; // Verifique o caminho correto
import Consultoria from './views/Consultoria'; // Verifique o caminho correto
import Consultancy from './ingles/Consultancy'; // Verifique o caminho correto
import TecnologiaDeinformação from './views/TecnologiaDeinformação'; // Verifique o caminho correto
import Projetos from './views/Projetos'; // Verifique o caminho correto
import Contacto from './views/Contacto'; // Verifique o caminho correto
import Contato from './views/Contato'; // Verifique o caminho correto

import Footer from './Components/Footer';
import ScrollToTop from './Components/ScrollToTop';

function App() {
  const [language, setLanguage] = useState('pt'); // Define o idioma inicial como português
  return (
    <Router>
       <ScrollToTop /> {/* <-- Aqui */}
      <Navbar1 language={language} setLanguage={setLanguage} />
      <Contato />
      <Routes>
        <Route path="/" element={language === 'pt' ? <Home /> : <Ingles language={language}/>} />
        <Route path="/ingles" element={language === 'pt' ? <Home /> : <Ingles language={language} />} />
        <Route path="/NossosServicos" element={<NossosServicos />} />
        <Route path="/Manutencaopredial" element={<Manutencaopredial />} />
        <Route path="/TecnologiaDeinformação" element={<TecnologiaDeinformação/>} />
        <Route path="/Consultoria" element={<Consultoria/>} />
        <Route path="/Consultancy" element={<Consultancy/>} />
        <Route path="/orcamento" element={<Orcamento/>} />
        <Route path="/Projetos" element={<Projetos/>} />
        <Route path="/OurTeam" element={<OurTeam/>} />
        <Route path="/InformationTechnology" element={<InformationTechnology/>} />
        <Route path="/Projects" element={<Projects/>} />
        <Route path="/NossoTeam" element={<NossoTeam />} />
        <Route path="/Who" element={<NossoTeam />} />
        <Route path="/a" element={<Orcamento />} />
        <Route path="/OurServices" element={<OurServices/>} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Building" element={<Building/>} />
        
      </Routes>
      <Footer language={language} />

    </Router>
  );
}

export default App;
